import type { InternalRequest } from '../client.js';
import type { Position } from '@trackizy/types';

export function positionsEndpoints(req: InternalRequest) {
  return {
    /** Latest known position per device (org-scoped). */
    latest: () => req.request<Position[]>('/positions'),
    /**
     * Historical positions for a device — route-replay endpoint.
     * There is NO /api/reports/route; replay must hit this path.
     * Returns ascending fixTime, 10k cap.
     */
    history: (deviceId: number | string, from: string, to: string) =>
      req.request<Position[]>(
        `/positions/${deviceId}?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`
      ),
  };
}
